(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Toula-club-1"] && !Shopify.designMode) return;
  try {
    
  function initToulaClubHero() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaClubHero);
  document.addEventListener("shopify:section:load", initToulaClubHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Toula-club-2"] && !Shopify.designMode) return;
  try {
    
  function initToulaMarquee() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaMarquee);
  document.addEventListener("shopify:section:load", initToulaMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Toula-club-3"] && !Shopify.designMode) return;
  try {
    
  function initToulaMissions() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaMissions);
  document.addEventListener("shopify:section:load", initToulaMissions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bullet-points-sobre-nos"] && !Shopify.designMode) return;
  try {
    
  function initToulaAnimations() {
    const animatedSections = document.querySelectorAll('[data-toula-animated="true"]');
    if (animatedSections.length === 0) return;

    const observerOptions = { threshold: 0.1, rootMargin: "0px 0px -50px 0px" };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const section = entry.target;
          section.classList.add('is-visible');
          
          const cards = section.querySelectorAll('.toula-card');
          cards.forEach(card => card.classList.add('is-visible'));
          
          observer.unobserve(section);
        }
      });
    }, observerOptions);

    animatedSections.forEach(section => observer.observe(section));
  }

  document.addEventListener("DOMContentLoaded", initToulaAnimations);
  document.addEventListener("shopify:section:load", initToulaAnimations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calendario"] && !Shopify.designMode) return;
  try {
    
  function initToulaBooking() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          requestAnimationFrame(() => { entry.target.classList.add('is-visible'); });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaBooking);
  document.addEventListener("shopify:section:load", initToulaBooking);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["checklist-homepage"] && !Shopify.designMode) return;
  try {
    
  function initToulaDiagnostic() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          requestAnimationFrame(() => { entry.target.classList.add('is-visible'); });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaDiagnostic);
  document.addEventListener("shopify:section:load", initToulaDiagnostic);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecossistema"] && !Shopify.designMode) return;
  try {
    
  function initToulaEcosystem() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          requestAnimationFrame(() => { entry.target.classList.add('is-visible'); });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaEcosystem);
  document.addEventListener("shopify:section:load", initToulaEcosystem);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["final-cta-sobre-nos"] && !Shopify.designMode) return;
  try {
    
  function initToulaLandscapeCTA() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaLandscapeCTA);
  document.addEventListener("shopify:section:load", initToulaLandscapeCTA);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-desbiose"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["indicado-para-disbiose"] && !Shopify.designMode) return;
  try {
    
  function initToulaIndications() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaIndications);
  document.addEventListener("shopify:section:load", initToulaIndications);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oula-club-how-it-works"] && !Shopify.designMode) return;
  try {
    
  function initToulaHowItWorks() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaHowItWorks);
  document.addEventListener("shopify:section:load", initToulaHowItWorks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-sobre-nos-heranca-clinica"] && !Shopify.designMode) return;
  try {
    
  function initToulaHeritage() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaHeritage);
  document.addEventListener("shopify:section:load", initToulaHeritage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-sobre-nos-manifesto-clinico"] && !Shopify.designMode) return;
  try {
    
  function initToulaManifesto() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    // Anima o container principal (Sticky)
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(sec => observer.observe(sec));

    // Anima cada bloco do lado direito individualmente à medida que se faz scroll
    const stepObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.2, rootMargin: "0px 0px -100px 0px" });

    document.querySelectorAll('[data-scroll-step]').forEach(step => {
      stepObserver.observe(step);
    });
  }

  document.addEventListener("DOMContentLoaded", initToulaManifesto);
  document.addEventListener("shopify:section:load", initToulaManifesto);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-sobre-nos-timeline"] && !Shopify.designMode) return;
  try {
    
  function initToulaSplitTimeline() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaSplitTimeline);
  document.addEventListener("shopify:section:load", initToulaSplitTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["podcast-e-sobre-a-toula"] && !Shopify.designMode) return;
  try {
    
  function initToulaStoryPodcast() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaStoryPodcast);
  document.addEventListener("shopify:section:load", initToulaStoryPodcast);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quebra-de-pagina"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(sec => observer.observe(sec));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toula-estrutura"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(sec => observer.observe(sec));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toula-evolution"] && !Shopify.designMode) return;
  try {
    
  function initToulaEvo() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaEvo);
  document.addEventListener("shopify:section:load", initToulaEvo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toula-podcast"] && !Shopify.designMode) return;
  try {
    
  function initToulaPodcast() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaPodcast);
  document.addEventListener("shopify:section:load", initToulaPodcast);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toula-tributo"] && !Shopify.designMode) return;
  try {
    
  function initToulaImageText() {
    const sections = document.querySelectorAll('[data-toula-animated="true"]');
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(sec => observer.observe(sec));
  }

  document.addEventListener("DOMContentLoaded", initToulaImageText);
  document.addEventListener("shopify:section:load", initToulaImageText);

  } catch(e) { console.error(e); }
})();
})();
